'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('../SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTriggers = (_temp = _class = function (_SvgIcon) {
  _inherits(NavTriggers, _SvgIcon);

  function NavTriggers() {
    _classCallCheck(this, NavTriggers);

    return _possibleConstructorReturn(this, (NavTriggers.__proto__ || Object.getPrototypeOf(NavTriggers)).apply(this, arguments));
  }

  _createClass(NavTriggers, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M4.154 23c-.056 0-.112-.01-.166-.032-.214-.086-.334-.32-.285-.55l1.72-8.043H.464c-.166 0-.318-.09-.4-.238-.083-.148-.084-.33-.002-.48L7.446.243c.114-.207.353-.295.568-.21.213.086.334.32.284.55L6.575 8.626h4.964c.164 0 .315.09.398.24.082.147.083.33.002.477L4.555 22.76c-.085.152-.24.24-.4.24z' })
        );
      }

      return render;
    }()
  }]);

  return NavTriggers;
}(_SvgIcon3['default']), _class.defaultProps = {
  preserveAspectRatio: 'xMidYMin',
  viewBox: '0 0 11.999998 22.999994'
}, _temp);
exports['default'] = NavTriggers;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Nav/NavTriggers.js
// module id = 1871
// module chunks = 32